/** Sync flag so Escape can close gallery without dismissing parent Sheet / För dig. */
let open = false;

export function setGalleryFullscreenOpen(next: boolean) {
  open = next;
}

export function isGalleryFullscreenOpen() {
  return open;
}
